var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from '../../helpers/Api';
import Extra from './Extra';
var ExtraStore = /** @class */ (function () {
    function ExtraStore() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.set = function (data) {
            _this.data = data.map(function (value) { return new Extra(value); });
            _this.loaded = true;
            return _this.data;
        };
        this.push = function (data) {
            _this.data.push(new Extra(data));
            return _this.data;
        };
        this.replace = function (data) {
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === data.id; }), 1, data);
        };
        this.pull = function (value) {
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === value.id; }), 1);
        };
    }
    ExtraStore.prototype.create = function (data) {
        return api.post('extras', data).then(this.push);
    };
    ExtraStore.prototype.disable = function (id, disabled) {
        return api.patch("extras/".concat(id), { disabled: disabled }).then(this.pull);
    };
    ExtraStore.prototype.read = function (id) {
        var eager = '[tax]';
        if (id)
            return api.get("extras/".concat(id, "?eager=").concat(eager));
        return api.get("extras?eager=".concat(eager)).then(this.set);
    };
    ExtraStore.prototype.update = function (id, data) {
        return api.put("extras/".concat(id), data)
            .then(this.replace);
    };
    __decorate([
        observable
    ], ExtraStore.prototype, "data", void 0);
    __decorate([
        observable
    ], ExtraStore.prototype, "loaded", void 0);
    __decorate([
        action
    ], ExtraStore.prototype, "set", void 0);
    __decorate([
        action
    ], ExtraStore.prototype, "push", void 0);
    __decorate([
        action
    ], ExtraStore.prototype, "replace", void 0);
    __decorate([
        action
    ], ExtraStore.prototype, "pull", void 0);
    return ExtraStore;
}());
export default ExtraStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Extras/ExtraStore.ts
// module id = 728
// module chunks = 0